const HIDE_ROUTE_NAMES = ['index']
const HIDE_ROUTE_PATHS = ['quiz', 'register', 'cancel', 'checkout', 'products']

let firstRun = true
function toggleWidgetView(to = {}) {
  const pathName = to?.path || window.location.pathname
  const path = pathName.split('/')
  const hasRouteName = HIDE_ROUTE_NAMES.includes(to?.name)
  const hasRoutePath =
    HIDE_ROUTE_PATHS.includes(path[1]) || HIDE_ROUTE_PATHS.includes(path[2])
  const hidePdpPath = path[1] === 'product' && window.innerWidth <= 767
  const status = hasRouteName || hasRoutePath || hidePdpPath ? 'hide' : 'show'

  const delay = firstRun ? 3000 : 250
  setTimeout(() => {
    if (window.zE) {
      window.zE('webWidget', status)
    }
  }, delay)
  firstRun = false
}

export default function (ctx) {
  ctx.app.router.afterEach(toggleWidgetView)

  if (!ctx.store.getters['user/customerId'] && window.zE) {
    window.zE('webWidget', 'logout')
  }

  ctx.app.$bus.$on('zendesk:toggle', toggleWidgetView)
}
